<template>
  <div>
    <hero-bar :has-right-visible="true">
      <div slot="title">Evaluaciones</div>
      <div slot="sub-title">Histórico de evaluaciones rendidas</div>
      <div slot="right">
        <div class="columns">
          <div class="column"></div>
          <div class="column is-narrow">
            <b-button type="is-primary" icon-left="plus" @click="isModalActive = true">Añadir Evaluación</b-button>
          </div>
        </div>
      </div>
    </hero-bar>
    <section class="section is-main-section">
      <evaluation-table :reload.sync="reloadTable" @edit="openFormEdit"/>
      <evaluation-form :active.sync="isModalActive" :event-id.sync="eventId" @saved="reloadTable = true"/>
    </section>
  </div>
</template>

<script>
import EvaluationTable from './components/EvaluationsTable'
import EvaluationForm from './components/EvaluationForm'
import HeroBar from '@/components/HeroBar'

export default {
  components: {
    HeroBar,
    EvaluationTable,
    EvaluationForm
  },
  created () {
  },
  data () {
    return {
      isModalActive: false,
      reloadTable: false,
      eventId: null
    }
  },
  methods: {
    openFormEdit (data) {
      this.eventId = data
      this.isModalActive = true
    }
  }
}
</script>
